import React, {PropsWithChildren} from 'react';
import { ThemeProvider, vars } from 'src/theme';
import { HashRouter } from 'react-router-dom';
import GlobalStyle from 'src/theme/GlobalStyle';
import { StoreContext } from 'storeon/react';
import { store } from 'src/store';
import 'antd/dist/antd.css';

interface Props {}

export const Providers: React.FC<Props> = (props:PropsWithChildren<Props>) => (

  <ThemeProvider theme={vars}>
    <HashRouter>
      <GlobalStyle />
      <StoreContext.Provider value={store}>
        {props.children}
      </StoreContext.Provider>
    </HashRouter>
  </ThemeProvider>
);
